module.exports = __webpack_public_path__ + "img/jxk_zgsy.30cbaa13.svg";